import { render } from "./baike.vue?vue&type=template&id=7bcaa86e&scoped=true"
import script from "./baike.vue?vue&type=script&lang=js"
export * from "./baike.vue?vue&type=script&lang=js"

import "./baike.vue?vue&type=style&index=0&id=7bcaa86e&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcaa86e"]])

export default __exports__